<template>
  <div class="multiple-input">
    <textarea
      class="multiple-input__textarea"
      rows="10"
      :placeholder="placeholder"
      :value="content"
      @input="handleInput($event.target.value)"
      @change="handleChange"
    ></textarea>
    <slot name="error" v-if="error">
      <span class="multiple-input__error">{{ error }}</span>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'VMultipleInput',

  props: {
    placeholder: {
      type: String
    },

    values: {
      type: Array,
      default: () => [],
      required: true
    },

    validate: {
      type: Function
    },

    filter: {
      type: Function
    }
  },

  data() {
    return {
      localValues: [...this.values]
    }
  },

  computed: {
    content() {
      return this.localValues.join('\n')
    },

    uniqueValues() {
      const uniqueValues = this.localValues.reduce((rows, row) => {
        const string = row.trim() || ''

        if (string) {
          if (!rows.includes(string)) {
            rows.push(string)
          }
        }

        return rows
      }, [])

      return uniqueValues
    },

    error() {
      let error = ''
      const { validate } = this

      if (validate) {
        this.localValues.some((value) => {
          if (value === '' || this.validate(value)) {
            return false
          }

          error = `${this.$t('c.input.errorInvalidValue')}: ${value}`
          return true
        })
      }

      return error
    }
  },

  watch: {
    values(values) {
      this.localValues = [...values]
    }
  },

  methods: {
    handleInput(value) {
      const array = value.replace('\r', '').split('\n')

      const { filter } = this
      const values = filter
        ? array.map(i => (i !== '' ? filter(i) : i))
        : array

      this.localValues = values
    },

    handleChange() {
      this.$emit('update:values', this.uniqueValues)
    }
  }
}
</script>


<style lang="scss">
@import "@/assets/style/scss/_vars.scss";
@import "@/assets/style/scss/_extends.scss";

.multiple-input {
  @extend %flex-column;
}
.multiple-input__textarea {
  resize: none;
  padding: 0.5em;
}
.multiple-input__error {
  margin-top: 0.5em;
  color: $tomato;
  font-size: 0.9em;
}
</style>
